'use client'

import { Skeleton } from '@/components/ui/skeleton'
import { useCareAndShareConfigs } from '@/hooks/react-query/care-and-share/use-configs'
import { ImageHelper } from '@/lib/helpers/image.helper'
import Image from 'next/image'

export const CampaignBanner = () => {
  const { data, isLoading } = useCareAndShareConfigs()

  if (isLoading) {
    return (
      <div className='px-4 pt-10 lg:px-16 lg:pt-20'>
        <Skeleton className='aspect-[16/9] w-full rounded-2xl md:aspect-[32/5]' />
      </div>
    )
  }

  if (
    !data?.section_banner ||
    !data.section_banner?.image ||
    !data.section_banner?.mb_image
  ) {
    return null
  }

  return (
    <div className='px-4 pt-10 lg:px-16 lg:pt-20'>
      <picture>
        <source
          media='(max-width: 768px)'
          srcSet={ImageHelper.getImageUrl(data.section_banner.mb_image)}
        />
        <Image
          src={ImageHelper.getImageUrl(data.section_banner.image)}
          alt='Care & Share New Collection'
          width={160}
          height={24}
          draggable={false}
          unoptimized
          className='w-full rounded-2xl object-cover'
        />
      </picture>
    </div>
  )
}
